import React from "react";
import {
  TableRowSkeleton,
  ProductInfoSkeleton,
  SkuSkeleton,
  TitleSkeleton,
  StatusSkeleton,
  PriceSkeleton,
  QtySkeleton,
  TotalSkeleton,
  TotalValSkeleton,
  RemoveBtnSkeleton,
  SidebarSkeletonCard,
  SidebarTitleSkeleton,
  SidebarRowSkeleton,
  SidebarLabelSkeleton,
  SidebarValSkeleton,
  SidebarButtonSkeleton,
  FormLabelSkeleton,
  FormInputSkeleton,
  BreadcrumbSkeleton,
} from "./CartSkeleton.styles";
import {
  StyledCartPageContainerDiv,
  StyledContinueBrowsingLink,
  StyledCartMainContentDiv,
  StyledCartTableContainerDiv,
  StyledCartTableHeaderContainerDiv,
  StyledCartTableHeaderDiv,
  StyledCartTableBodyDiv,
  StyledCartSidebarContainerDiv,
} from "../index.styles";
import { BackArrow } from "../../assets/icons";

export const CartSkeleton = () => {
  return (
    <StyledCartPageContainerDiv>
      <StyledContinueBrowsingLink disabled style={{ opacity: 0.7 }}>
        <BackArrow />
        <span>Continue Browsing</span>
      </StyledContinueBrowsingLink>

      <BreadcrumbSkeleton />

      <StyledCartMainContentDiv>
        <StyledCartTableContainerDiv>
          <StyledCartTableHeaderContainerDiv>
            <StyledCartTableHeaderDiv className="product">Product</StyledCartTableHeaderDiv>
            <StyledCartTableHeaderDiv className="unit-price">Unit Price</StyledCartTableHeaderDiv>
            <StyledCartTableHeaderDiv className="qty">Qty</StyledCartTableHeaderDiv>
            <StyledCartTableHeaderDiv className="total">Total</StyledCartTableHeaderDiv>
          </StyledCartTableHeaderContainerDiv>

          <StyledCartTableBodyDiv>
            {Array.from({ length: 3 }).map((_, idx) => (
              <TableRowSkeleton key={idx}>
                <div style={{ flex: 2 }}>
                  <ProductInfoSkeleton>
                    <SkuSkeleton />
                    <TitleSkeleton />
                    <StatusSkeleton />
                  </ProductInfoSkeleton>
                </div>
                <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                  <PriceSkeleton />
                </div>
                <div style={{ flex: 1.2, display: "flex", justifyContent: "center" }}>
                  <QtySkeleton />
                </div>
                <TotalSkeleton>
                  <TotalValSkeleton />
                  <RemoveBtnSkeleton />
                </TotalSkeleton>
              </TableRowSkeleton>
            ))}
          </StyledCartTableBodyDiv>
        </StyledCartTableContainerDiv>

        <StyledCartSidebarContainerDiv>
          <SidebarSkeletonCard>
            <SidebarTitleSkeleton />
            <SidebarRowSkeleton>
              <SidebarLabelSkeleton />
              <SidebarValSkeleton />
            </SidebarRowSkeleton>
            <SidebarButtonSkeleton />
            <SidebarButtonSkeleton />
          </SidebarSkeletonCard>

          <SidebarSkeletonCard>
            <SidebarTitleSkeleton />
            <FormLabelSkeleton />
            <FormInputSkeleton />
            <FormLabelSkeleton />
            <FormInputSkeleton />
          </SidebarSkeletonCard>
        </StyledCartSidebarContainerDiv>
      </StyledCartMainContentDiv>
    </StyledCartPageContainerDiv>
  );
};
